import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ClusterDialogData } from '@app/shared/components/dialogs/cluster-dialog/cluster-dialog.data';

@Component({
    selector : 'cluster-dialog',
    template: require('./cluster-dialog.component.html'),
    styles: [require('./cluster-dialog.component.scss')]
})
export class ClusterDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: ClusterDialogData) {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/cluster-dialog/cluster-dialog.component.ts